import { render, staticRenderFns } from "./barraBuscaProdutos.vue?vue&type=template&id=9beee2d6&scoped=true"
import script from "./barraBuscaProdutos.vue?vue&type=script&lang=js"
export * from "./barraBuscaProdutos.vue?vue&type=script&lang=js"
import style0 from "./barraBuscaProdutos.vue?vue&type=style&index=0&id=9beee2d6&prod&lang=css"
import style1 from "./barraBuscaProdutos.vue?vue&type=style&index=1&id=9beee2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9beee2d6",
  null
  
)

export default component.exports